module.exports = __webpack_public_path__ + "img/options5_2.c6136867.png";